module.exports = require("@visx/pattern");